'use strict';
/* Kalis/Claude - judge.me leex masonry: relayout whenever a review card changes height.
 *
 * The leex widget theme positions cards with Metafizzy Masonry, which measures every card
 * once and writes absolute top/transform values. shopify_v2_leex.js re-runs the layout on
 * 9 judge.me events, but none of them fire when a review body is auto-translated
 * (widget_translate_review_content_method = 'automatic'). A card that grows after the
 * layout leaves every card below it at a stale position - measured overlaps of 400-544px
 * on the PDP. Photo loading, "Les mer" truncation and late webfonts do the same thing, and
 * masonry never re-lays-out on resize/orientation change either.
 *
 * Instead of guessing which async step changed the height, observe the cards and relayout
 * on any size change. Debounced, so masonry's own height change settles in one extra pass.
 */

(function () {
  var CONTAINERS = '.jdgm-rev-widg__reviews, .jdgm-all-reviews__body, .jdgm-revs-tab__reviews, .jdgm-shop-reviews__body';
  var DEBOUNCE_MS = 60;

  if (typeof ResizeObserver === 'undefined') return;

  function attach(el) {
    var $ = window.jdgm && window.jdgm.$;
    if (!$) return;

    var $el = $(el);
    if (!$el.data('masonry')) return;    // masonry not initialised on this container yet
    if (el.dataset.kalisMasonryRelayout) return;
    el.dataset.kalisMasonryRelayout = '1';

    var timer;
    function relayout() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if ($el.data('masonry')) $el.masonry('layout');
      }, DEBOUNCE_MS);
    }

    var ro = new ResizeObserver(relayout);

    function observeCards() {
      // observe() on an already-observed element is a no-op, so this is safe to re-run
      el.querySelectorAll(':scope > .jdgm-rev').forEach(function (card) {
        ro.observe(card);
      });
    }

    observeCards();
    ro.observe(el);   // container width: covers resize and orientation change

    new MutationObserver(function () {
      observeCards();
      relayout();
    }).observe(el, { childList: true, subtree: true, characterData: true });

    window.addEventListener('resize', relayout);
    relayout();
  }

  function hook() {
    document.querySelectorAll(CONTAINERS).forEach(attach);
  }

  // Masonry is set up on doneSetup and re-created when more reviews / other tabs load.
  ['jdgm.doneSetup', 'jdgm.doneSetupReviews', 'jdgm.doneAppendMoreReviews',
   'jdgm.doneShowReviewsTab', 'jdgm.doneLoadingCss'].forEach(function (name) {
    document.addEventListener(name, hook, false);
  });

  // The widget loads lazily and code-split, so poll briefly as a safety net (20s).
  var tries = 0;
  var poll = setInterval(function () {
    hook();
    if (++tries > 40) clearInterval(poll);
  }, 500);

  hook();
})();
